import { useEffect } from 'react';

import { useInView } from 'Shared/hooks/useInView';

import { trackEvent } from './audioService/utils';

type ParamsT = {
  readonly entityId: string;
  readonly title: string;
};

export const useAudioButtonShownEvent = <T extends HTMLElement>({
  entityId,
  title,
}: ParamsT) => {
  const [inViewRef, isVisible] = useInView<T>({ triggerOnce: true });

  useEffect(() => {
    if (isVisible) {
      trackEvent('shown', { entityId, title });
    }
  }, [isVisible, entityId, title]);

  return inViewRef;
};
